/**
 * Module config — kept in its own file to avoid the circular import that
 * happens when buildActiveMap.ts imports from './index.js' while index.ts
 * also re-exports buildActiveMap (Wrangler/esbuild bundling can resolve the
 * binding to undefined under the cycle).
 */

import type { QAModule } from './types.js';

export const MODULE_CONFIG: readonly Pick<
  QAModule,
  'id' | 'displayName' | 'fullControlBonus' | 'revealAtPlayers'
>[] = [
  { id: 'frontend', displayName: 'Frontend UI', fullControlBonus: 2, revealAtPlayers: 2 },
  { id: 'backend', displayName: 'Backend Logic', fullControlBonus: 3, revealAtPlayers: 2 },
  { id: 'database', displayName: 'Database', fullControlBonus: 2, revealAtPlayers: 3 },
  { id: 'security', displayName: 'Security', fullControlBonus: 4, revealAtPlayers: 4 },
  { id: 'devops', displayName: 'DevOps', fullControlBonus: 3, revealAtPlayers: 5 },
  { id: 'compliance', displayName: 'Compliance', fullControlBonus: 5, revealAtPlayers: 6 },
] as const;

